import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Plus, X, ImageIcon } from 'lucide-react';

const MAX = 5;

export const ScreenshotsPicker = ({ files, onChange, prefix }) => {
    const add = (e) => {
        const picked = Array.from(e.target.files || []);
        e.target.value = '';
        onChange([...files, ...picked].slice(0, MAX));
    };
    return (
        <div className="space-y-1.5" data-testid={`${prefix}-screenshots`}>
            <Label className="text-xs">Payment screenshot(s) · up to {MAX}</Label>
            <div className="flex flex-wrap gap-2">
                {files.map((f, i) => (
                    <div key={`${f.name}-${i}`} className="relative h-16 w-16 overflow-hidden rounded-lg border border-border bg-secondary" data-testid={`${prefix}-screenshot-item-${i}`}>
                        <img src={URL.createObjectURL(f)} alt={f.name} className="h-full w-full object-cover" />
                        <button type="button" onClick={() => onChange(files.filter((_, j) => j !== i))} className="absolute right-0.5 top-0.5 rounded-full bg-black/60 p-0.5 text-white" data-testid={`${prefix}-screenshot-remove-${i}`}><X className="h-3 w-3" /></button>
                    </div>
                ))}
                {files.length < MAX && (
                    <label className="flex h-16 w-16 cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-border text-muted-foreground hover:border-foreground/40" data-testid={`${prefix}-screenshot-add`}>
                        {files.length ? <Plus className="h-5 w-5" /> : <ImageIcon className="h-5 w-5" />}
                        <span className="text-[10px] mt-0.5">{files.length ? 'Add more' : 'Add'}</span>
                        <input type="file" multiple accept="image/png,image/jpeg,image/webp" className="hidden" onChange={add} data-testid={`${prefix}-screenshot`} />
                    </label>
                )}
            </div>
        </div>
    );
};

export const BankFields = ({ form, setForm, prefix }) => (
    <>
        <div className="space-y-1.5">
            <Label className="text-xs">Your bank name</Label>
            <Input placeholder="e.g. HDFC Bank" value={form.bank_name} onChange={e => setForm(f => ({ ...f, bank_name: e.target.value }))} data-testid={`${prefix}-bank-name`} />
        </div>
        <div className="space-y-1.5">
            <Label className="text-xs">IFSC code</Label>
            <Input placeholder="e.g. HDFC0001234" maxLength={11} value={form.ifsc} onChange={e => setForm(f => ({ ...f, ifsc: e.target.value.toUpperCase() }))} data-testid={`${prefix}-ifsc`} />
        </div>
    </>
);

export const validateBank = (form) => {
    if (!String(form.bank_name || '').trim()) return 'Please enter your bank name';
    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(String(form.ifsc || '').trim().toUpperCase())) return 'Enter a valid 11-character IFSC code';
    return null;
};
